<template>
    <div class="customer-dashboard">
        <div class="IFrameLoader" id="my-superset-container">
            <h1>Dashboard is being loaded ...</h1>
        </div>
    </div>
</template>

<script>
import {
    helperFunctionMixin,
    axios,
    services,
    getHeader
} from '@/assets/js/httpImports.js'
import { embedDashboard } from "@superset-ui/embedded-sdk";
import { APACHE_SUPERSET } from '@/assets/js/config';
export default {
    mixins: [helperFunctionMixin],
    methods: {
        getDashboardId() {
            return "391dfcb8-98c9-4c40-9e4f-8a561d7b0ba9";
        },
        async guestToken(){
            const dashboard_id = this.getDashboardId();
            const apache_superset_token = localStorage.getItem(`superset_token_${dashboard_id}`) || '';
            const result = await axios.get(services.access_control+'get_dashboard_token', {
                headers: getHeader(),
                params: {
                    dashboard_id,
                    apache_superset_token
                }
            });
            const token = result.data.token;
            if (token) {
                localStorage.setItem(`superset_token_${dashboard_id}`, token);
                return token;
            }
            return token;
        }
    },
    created() {
        setTimeout(() => {
            embedDashboard({
                id: this.getDashboardId(),
                supersetDomain: APACHE_SUPERSET,
                mountPoint: document.getElementById("my-superset-container"),
                fetchGuestToken: () => this.guestToken(),
                dashboardUiConfig: {
                    hideTitle: true,
                    filters: {
                        expanded: false,
                        visible: false
                    },
                },
            });
        }, 2000);
    }
}
</script>